import React from 'react';
import Header from 'components/Header';
import Footer from 'components/Footer';
import PropTypes from 'prop-types';
import Loader from 'components/ui/Loader';
import AlertModal from 'components/ui/AlertModal';

const AdminLayout = (props) => {
  const { path } = props;

  return (
    <>
      <Loader />
      <AlertModal />
      <Header path={path} />
      {props.children}
      <Footer />
    </>
  );
};

AdminLayout.propTypes = {
  path: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
};

export default AdminLayout;
